import React, { FC, PropsWithChildren, createContext, useState } from 'react';
import { Helmet } from 'react-helmet';

interface IHeadContextValues {
  setTitle: (value: string) => void;
}

const HeadContext = createContext<IHeadContextValues>({
  setTitle: () => undefined,
});

export const HeadProvider: FC<PropsWithChildren> = ({ children }) => {
  const [title, setTitle] = useState<string>();

  return (
    <HeadContext.Provider
      value={{
        setTitle,
      }}
    >
      <Helmet>
        <title>
          {title ? `${title} - ` : ''}
          FoodRoots
        </title>
      </Helmet>
      {children}
    </HeadContext.Provider>
  );
};

export default HeadContext;
